export default __webpack_public_path__ + "static/5-d20540754b5467a19e9df561d6c91a7a.png";